<template>
  <v-app id="app">
    <TopNavBar v-if="$route.meta.header" />
    <v-content>
      <v-container fluid>
        <router-view />
      </v-container>
    </v-content>
    <PageFooter v-if="$route.meta.footer" />
  </v-app>
</template>

<script>
import TopNavBar from '@/components/TopNavBar';
import PageFooter from '@/components/PageFooter';

export default {
  components: {
    TopNavBar,
    PageFooter,
  },
  beforeUpdate() {
    //console.log('!!!!!!');
  },
};
</script>
